import { render, staticRenderFns } from "./ProductIntelligencePanel.vue?vue&type=template&id=e2a4b4f4"
import script from "./ProductIntelligencePanel.vue?vue&type=script&lang=js"
export * from "./ProductIntelligencePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports